import moment from "moment";

export function formatDate(text, type = 'YYYY-MM-DD') {
    return text ? moment(text).format(type) : ''
}

export function formatBoolean(text, type) {
    return text ? this.$t('message.commonUsage.yes') : this.$t('message.commonUsage.no')
}

export function formatAmount(num,separator = ',') {
    return num ? num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, separator) : '--';
}


export function formatMobile(mobile,separator = '****') {
    return mobile.replace(/^(\d{3})\d{4}(\d{4})$/, `$1${separator}$2`);

}